<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div>
    <!-- 文化和价值观 -->
    <section id="cultureAndValues" class="py-20 bg-gray-50">
      <div class="container mx-auto px-6">
        <h2
          class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4"
        >
          文化和价值观
        </h2>
        <div class="w-20 h-1 bg-yellow-400 mx-auto mb-6"></div>
        <p class="text-center text-gray-600 mb-16 max-w-3xl mx-auto">
          这是一个源自骑行爱好者群体的品牌与平台，以联结伙伴、共享骑行乐趣为核心，传递善意与温暖，让每一份付出都能收获快乐。
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
          <div class="row-span-2">
            <h3 class="text-2xl font-bold mb-4">核心理念</h3>
            <b>开放：</b>
            以积极主动的心态拥抱一切可能，不设壁垒，欢迎所有对骑行感兴趣的人加入，共同探索未知的乐趣。<br />
            <b>包容：</b
            >以宽阔的胸怀尊重差异，不论骑行经验、背景、风格如何，都能在群体中找到共处之道，彼此理解与支持。<br />
            <b>接纳：</b
            >为每一位伙伴提供灵魂的归属，让大家在骑行中感受到被认可、被需要，形成紧密的情感联结。<br />
            <b>探索：</b
            >以骑行为纽带突破边界，在未知旅程中发现自我与世界的更多可能，让每段路程都成为成长的契机。<br />
            <b>共进：</b
            >汇聚个体力量形成前行合力，彼此赋能、相互成就，在骑行路上同步抵达更远的未来。
          </div>
          <div>
            <h3 class="text-2xl font-bold mb-4">价值主张</h3>
            强调
            “善意与温暖的循环”：付出的善意终会以快乐形式回归，鼓励伙伴们在互动中传递正能量。
            重视
            “相遇的意义”：无论来自何方，只要因骑行相识，便珍惜这份缘分，不负遇见，携手同行。
          </div>
          <div>
            <h3 class="text-2xl font-bold mb-4">愿景</h3>
            骑行连接城乡，绿色驱动发展，创新迈向智慧未来。
          </div>
        </div>
      </div>
    </section>
    <!-- 里程碑 -->
    <div id="milestone" class="container mx-auto px-4 py-20">
      <h2 class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4">
        里程碑
      </h2>
      <div class="w-20 h-1 bg-yellow-400 mx-auto mb-6"></div>
      <p class="text-center text-gray-600 mb-16 max-w-3xl mx-auto">
        这是一个源自骑行爱好者群体的品牌与平台，以联结伙伴、共享骑行乐趣为核心，传递善意与温暖，让每一份付出都能收获快乐。
      </p>
      <div class="flex flex-col lg:flex-row gap-8 lg:gap-16 text-xl">
        <!-- 左侧时间选择区 -->
        <div
          class="lg:w-1/4 flex flex-row md:flex-col items-center md:h-72 justify-between"
        >
          <!-- 上一年按钮 -->
          <button
            @click="changeYear(-1)"
            class="md:mb-4 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-primary hover:text-white transition-all duration-300"
            :disabled="isFirstGroup"
            :class="{ 'opacity-50 cursor-not-allowed': isFirstGroup }"
          >
            <i class="fa fa-chevron-up"></i>
          </button>

          <!-- 年份显示（仅3个） -->
          <div
            class="md:space-y-4 md:my-2 flex flex-row md:flex-col justify-center items-center"
          >
            <div
              v-if="showPrevYear"
              @click="activeYear = prevYear"
              class="cursor-pointer py-3 px-6 rounded-lg transition-all duration-300 hover:bg-secondary text-center text-lg font-medium text-gray-600"
            >
              {{ prevYear }}
            </div>

            <div
              @click="activeYear = currentYear"
              class="cursor-pointer py-3 px-6 rounded-lg transition-all duration-300 bg-primary text-white text-center text-2xl font-bold shadow-md transform hover:scale-105 bg-yellow-400"
            >
              {{ currentYear }}
            </div>

            <div
              v-if="showNextYear"
              @click="activeYear = nextYear"
              class="cursor-pointer py-3 px-6 rounded-lg transition-all duration-300 hover:bg-secondary text-center text-lg font-medium text-gray-600"
            >
              {{ nextYear }}
            </div>
          </div>

          <!-- 下一年按钮 -->
          <button
            @click="changeYear(1)"
            class="md:mt-4 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-primary hover:text-white transition-all duration-300"
            :disabled="isLastGroup"
            :class="{ 'opacity-50 cursor-not-allowed': isLastGroup }"
          >
            <i class="fa fa-chevron-down"></i>
          </button>
        </div>

        <!-- 右侧内容展示区 -->
        <div class="lg:w-3/4">
           <div
             class="relative w-full md:h-72 overflow-y-auto scrollbar-hide rounded-lg border-t border-gray-200 p-4 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.06),-1px_0_0_rgba(0,0,0,0.05),0_-1px_0_rgba(0,0,0,0.05)]"
           >
            <!-- 时间线 -->
            <!-- <div class="absolute left-0 top-0 bottom-0 w-1 bg-gray-200"></div> -->

            <!-- 里程碑内容列表 -->
            <div
              v-for="(item, index) in filteredMilestones"
              :key="index"
              class="relative pl-8 py-3 transition-all duration-300"
            >
              <!-- 内容卡片 -->
              <div class="bg-white">
                <div class="flex items-start text-left">
                  <!-- 月份 -->
                  <div class="text-base font-semibold text-gray-500 mr-4 w-16">
                    {{ item.month }}
                  </div>

                  <!-- 内容 -->
                  <div class="flex-1 text-sm">
                    <p class="text-gray-800">
                      {{ item.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 空状态提示 -->
            <div
              v-if="filteredMilestones.length === 0"
              class="text-center py-12 text-gray-500"
            >
              该年份暂无里程碑记录
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 领导团队 -->
    <section id="leadershipTeam" class="py-20 bg-gray-50">
      <div class="container mx-auto px-6">
        <h2
          class="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4"
        >
          领导团队
        </h2>
        <div class="w-20 h-1 bg-yellow-400 mx-auto mb-6"></div>
        <p class="text-center text-gray-600 mb-16 max-w-3xl mx-auto">
          这是一个源自骑行爱好者群体的品牌与平台，以联结伙伴、共享骑行乐趣为核心，传递善意与温暖，让每一份付出都能收获快乐。
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
          <div >
            <h3 class="text-2xl font-bold mb-4">创始人</h3>
            拥有 30 年骑行经验的资深爱好者，曾获环青海湖挑战赛冠军，如今是推动行业标准化的践行者。
            始终坚信 “骑行是连接人与世界的最佳方式”，凭借对骑行文化的深刻理解，牵头搭建开放平台，
            让每一份热爱都能找到生长的土壤。
          </div>
          <div>
            <h3 class="text-2xl font-bold mb-4">首席运营官</h3>
            在户外运动产业深耕十余年，善于将前沿理念转化为落地实践。主导的 “骑行生态伙伴计划”，
            已联结 200 + 城市骑行社群，通过系统化运营，让 “包容共生” 的理念渗透到每一次蹬踏之间。
          </div>
          <div>
            <h3 class="text-2xl font-bold mb-4">技术总监</h3>
            曾是互联网大厂技术骨干，因一场川藏线骑行毅然转型。带领团队研发的智能骑行系统，
            借助数据赋能让探索更具方向感，同时始终保留 “用车轮丈量大地” 的原始浪漫。
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
SwiperCore.use([Pagination, Autoplay]);
// 引入样式
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper
const swiperModules = [Pagination, Autoplay];



// 里程碑数据
// 响应式状态
const activeYear = ref(2025);
const currentIndex = ref(0);

// 数据
const years = [2025];
const milestones = [
  {
    year: 2025,
    month: "一月",
    content: "北境骑团宣布升级骑行战略，设立骑行优化目标。",
  },
  {
    year: 2025,
    month: "五月",
    content:
      "北境骑团启动“骑行生态伙伴”计划，助力人们在骑行中获得更好的生活体验。",
  },
];

// 计算属性
const currentYear = computed(() => years[currentIndex.value]);
const prevYear = computed(() => years[currentIndex.value - 1]);
const nextYear = computed(() => years[currentIndex.value + 1]);

const showPrevYear = computed(() => currentIndex.value > 0);
const showNextYear = computed(() => currentIndex.value < years.length - 1);

const isFirstGroup = computed(() => currentIndex.value === 0);
const isLastGroup = computed(() => currentIndex.value === years.length - 1);

const filteredMilestones = computed(() =>
  milestones.filter((item) => item.year === activeYear.value)
);

// 方法
const changeYear = (direction) => {
  if (direction === -1 && currentIndex.value > 0) {
    currentIndex.value--;
    activeYear.value = years[currentIndex.value];
  }

  if (direction === 1 && currentIndex.value < years.length - 1) {
    currentIndex.value++;
    activeYear.value = years[currentIndex.value];
  }
};

// 初始化
activeYear.value = currentYear.value;

onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，
  // 当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，
  // 提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  // window.addEventListener("scroll", () => {
  //   const nav = document.querySelector("nav");
  //   if (window.scrollY > 100) {
  //     nav?.classList.add("shadow-md");
  //   } else {
  //     nav?.classList.remove("shadow-md");
  //   }
  // });
});
</script>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
}
</style>
